module.exports = __webpack_public_path__ + "img/num3.06dbb6e0.svg";